var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 879,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 880,
	"./assets/thewest-digital-hero-variation-a.jpg": 2995,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 881,
	"./assets/thewest-digital-hero-variation-b.jpg": 2996,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 882,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2997,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 883,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2998,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 884,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2999,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile.jpg": 885,
	"./assets/thewest-digital-hero-variation-footy-lives-here.jpg": 3000,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 886,
	"./assets/thewest-digital-hero-variation-summer-of-cricket.jpg": 3001,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 887,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 3002,
	"./assets/thewest-digital-hero.jpg": 3003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 611;